import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { toast } from 'react-toastify';
import { exportProtocolToPdf } from '../../utils/protocol-export.util';

// Shared by the wizard's review step and the saved-protocol list, so a
// protocol exported before saving and one exported afterwards produce the
// same document.
export default function ProtocolExportActions({
  protocol,
  subcategoriesLabel,
  categoriesLabel,
  size,
}) {
  const [printing, setPrinting] = useState(false);

  const hasActivities = (protocol?.days || []).some(
    (day) => day.activities?.length > 0
  );

  const handlePdf = async () => {
    if (!hasActivities) {
      toast.error('Protokol nema definisanih aktivnosti za izvoz');
      return;
    }
    setPrinting(true);
    try {
      await exportProtocolToPdf(protocol, { subcategoriesLabel, categoriesLabel });
    } catch (error) {
      console.error('Error exporting protocol to PDF:', error);
      toast.error('Greška pri pripremi PDF dokumenta');
    } finally {
      setPrinting(false);
    }
  };

  return (
    <Button
      className="btn-tertiary"
      size={size}
      onClick={handlePdf}
      loading={printing}
      icon={
        <img
          src="/assets/icons/download.svg"
          alt=""
          style={{ width: 16, height: 16 }}
        />
      }
    >
      Preuzmi PDF
    </Button>
  );
}

ProtocolExportActions.propTypes = {
  protocol: PropTypes.object.isRequired,
  subcategoriesLabel: PropTypes.string,
  categoriesLabel: PropTypes.string,
  size: PropTypes.string,
};
